// @ts-check

import { checkStrings } from 'libs/types/checkTypes';

/**
 * @function filterRoleGroupsOptions
 * @param {RoleGroupType[]} options
 * @param {Object[]} userRoleGroups
 * @param {string} userRoleGroups.id
 * @param {string} userRoleGroups.name
 * @returns {RoleGroupOptionType[]}
 */
export function filterRoleGroupsOptions(options, userRoleGroups) {
	const newOptions = options.map((option) => {
		checkStrings(option.name);
		const appName = option.name.split('_')[0];
		return { ...option, appName: appName };
	});

	const filtered = newOptions.filter((option) =>
		userRoleGroups.some((userRole) => {
			checkStrings(option.name, userRole.name);
			return option.name.split('_')[0] === userRole.name.split('_')[0];
		}),
	);

	return filtered;
}

/**
 * @function makeGroupByAppId
 * @param {RoleGroupOptionType} option
 * @returns {string}
 */
export function makeGroupByAppId(option) {
	return option.appName;
}

/**
 * @function getOptionLabel
 * @param {RoleGroupType} option
 * @returns {string}
 */
export function getOptionLabel(option) {
	return option.name ? option.name : '';
}
